import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setInformativeTexts = events => {
  return {
    type: ActionTypes.LOAD_INFORMATIVETEXTS,
    events: events
  };
};

export const onUpdateInformativeText = response => {
  return {
    type: ActionTypes.MODIFY_INFORMATIVETEXT,
    response: response
  };
};

export const loadInformativeTexts = () => {
  return dispatch => {
    axios
      .get("http://190.105.227.203/baroloapi/informativetexts")
      .then(response => {
        dispatch(setInformativeTexts(response.data));
      })
      .catch(error => {});
  };
};

export const updateInformativeText = informativeText => {
  return dispatch => {
    axios
      .put("http://190.105.227.203/baroloapi/updateinformativetexts", informativeText)
      .then(response => {
        dispatch(onUpdateInformativeText(response.data));
      })
      .catch(error => {
        console.log(error);
      })
    
  };
};
